import axios, { Axios, type AxiosRequestConfig } from 'axios'

class ClientApi {
  api: Axios

  constructor() {
    this.api = axios.create({ baseURL: '/api' })
  }

  /** Send a GET request; `config` can add headers such as `Authorization`. */
  get(path: string, config?: AxiosRequestConfig): Promise<any> {
    return this.api.get(path, config)
  }
  post(path: string, payload: any): Promise<any> {
    return this.api.post(path, payload)
  }
}

const clientApi = new ClientApi()

export default clientApi
